import React, { useState, useEffect, useRef } from 'react'

import { Button, Grid, Dialog, Collapse, Icon, Typography } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import DialogLoader from '../../../../components/Loader/DialogLoader';
import SearchGrid from "./../../../../components/table/SearchGrid";

import NoRecord from "./../../../../components/NoRecord/NoRecord";
import { PostDataAPI } from '../../../../Services/APIService';
import { formateMdnNumber, formatDateTime, getFormatedDate, formatSizeUnits, convertMinToHours, formatDateTime2, formatDateTime3, formatCurrency, formatDate } from '../../../../components/Common/Extensions';
import profilePlaceholder from '../../../../assets/img/profilePlaceholder.webp';
import GlobeIcon from '../../../../assets/img/status/globalization.svg';
import CallIcon from '../../../../assets/img/status/call.svg';
import SMSIcon from '../../../../assets/img/status/sms.svg';
import { DraggableComponent } from '../../../../components/UiElements/UiElements';
import moment from 'moment';
import { withSnackbar } from "../../../../components/Message/Alert";
import useStyles from "./styles";
import './style.css'

function MonthlyUsageSummary({ dialogOpenClose, handleClose, searchFilter, dateFilters, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [selectedDateRange, setSelectedDateRange] = useState(dateFilters);
    const [isLoading, setIsLoading] = useState(false);
    const [websiteUrl, setWebsiteUrl] = useState('http://209.105.227.82/fCIdemo/')
    
    const [reportHtmlContent, setReportHtmlContent] = useState();
    const printRef = useRef();

    const printReport = () => {
        const content = printRef.current.innerHTML;

        const printWindow = window.open('', '_blank', 'width=800,height=600');
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        /* Add necessary styles for printing */
                        body {
                            font-family: Arial, sans-serif;
                            margin: 20px;
                        }
                        h2, h3, h4, h5 {
                            margin: 10px 0;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }
                        table, th, td {
                            border: 1px solid black;
                        }
                        th, td {
                            padding: 8px;
                            text-align: left;
                        }
                        img {
                            max-width: 100%;
                        }
                    </style>
                </head>
                <body>
                    ${content}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();


        // Create a hidden iframe
        //const iframe = document.createElement('iframe');
        //iframe.style.position = 'absolute';
        //iframe.style.width = '0px';
        //iframe.style.height = '0px';
        //iframe.style.border = 'none';

        //// Append iframe to the body
        //document.body.appendChild(iframe);

        //// Get iframe document and write HTML content
        //const doc = iframe.contentDocument || iframe.contentWindow.document;
        //doc.open();
        //doc.write(reportHtmlContent);
        //doc.close();

        //// Print iframe content
        //iframe.contentWindow.focus();
        //iframe.contentWindow.print();

        //// Remove iframe from the DOM after printing
        //setTimeout(() => {
        //    document.body.removeChild(iframe);
        //}, 100);
    }

    const [userReportRecord, setUsageReportRecord] = useState([]);

    const handleExport = () => {
        var params = {
            mdnNumber: props.mdnNumber,
            accountNumber: props.accountNumber,
            fromDate: getFormatedDate(selectedDateRange.fromDate, 'YYYY-MM-DD') + '',
            toDate: getFormatedDate(selectedDateRange.toDate, 'YYYY-MM-DD') + '',
            searchFilter: searchFilter
        }

        setIsLoading(true)
        PostDataAPI("telispire/exportMonthlyUsageDetails", params, true).then((result) => {
            setIsLoading(false)
            if (result.success && result.data) {
                
                setUsageReportRecord(result.data)
                //setReportHtmlContent(result.data);
                //const blob = new Blob([result.data], { type: 'text/html' });
                //const url = URL.createObjectURL(blob);
                //window.open(url, '_blank');
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            
        })
    }

    useEffect(() => {
        handleExport();
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Usage Report</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
                  
                    <div className={classes.content}>
                        {isLoading ? <DialogLoader></DialogLoader> : ''}
                        
                        <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={600} >
                            <div ref={printRef}>
                            <div className="page">
                                <img
                                    style={{ display: 'block', maxWidth: '100%', lineHeight: 1, fontSize: 0 }}
                                        src={`${websiteUrl}fm-assets/general/front_page.jpg`}
                                    alt="Front Page"
                                />
                            </div>
                    
                            {userReportRecord?.map((report, index) => (
                                <div key={index} className={classes.content}>
                                    <div>
                                        <div className="page">
                                            <img
                                                src={`${websiteUrl}fm-assets/general/header.jpg`}
                                                style={{ display: 'block', maxWidth: '100%', lineHeight: 1, fontSize: 0 }}
                                                alt="fcp usage report header"
                                            />

                                            <div className={classes.page_container}>
                                                <div className={classes.userInfo}>
                                                    <div className={classes.userImg}>
                                                        <img src={`${websiteUrl}fm-assets/general/user_placeholder.jpg`} width="150" alt="User" />
                                                    </div>
                                                    <div className="usage-report-info">
                                                        <div className={classes.usageReportInfoInner}>
                                                            <h3>{report?.line?.username || 'N/A'}</h3>
                                                            <h3>{formateMdnNumber(report?.line?.mDN) || 'N/A'}</h3>
                                                            <h3 style={{ textWrap: 'nowrap' }}>ICC Number: {report?.line?.iCC || 'N/A'}</h3>
                                                            <h3>Active Since: {formatDateTime(report?.line?.activationDate) || 'N/A'}</h3>
                                                        </div>
                                                    </div>

                                                    <div className="usage-report-status">
                                                        <h5>Line Status</h5>
                                                        <h4>{report?.line?.status || 'Unknown'}</h4>
                                                        <h5>{report?.line?.isPrepaid ? 'Prepaid' : 'Postpaid'}</h5>
                                                    </div>
                                                </div>

                                                <h2 style={{ textAlign: 'center', margin: '19px 0' }}>Monthly Report</h2>
                                                <div className={classes.userInfo}>
                                                    <div className={classes.graphCircle}>
                                                        <h2>Call</h2>
                                                        {report?.callDetails?.length || 0}
                                                    </div>

                                                    <div className={classes.graphCircle}>
                                                        <h2>Text</h2>
                                                        {report?.sMSDetails?.length || 0}
                                                    </div>

                                                    <div className={classes.graphCircle}>
                                                        <h2>Data</h2>
                                                        {report?.dataDetails?.length || 0}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="page">
                                            <img
                                                src={`${websiteUrl}fm-assets/general/header.jpg`}
                                                style={{ display: 'block', maxWidth: '100%', lineHeight: 1, fontSize: 0 }}
                                                alt="fcp usage report header"
                                            />

                                            <div className="page_container">
                                                <h2 style={{ textAlign: 'center', margin: '19px 0' }}>SMS/MMS Details</h2>
                                                <div style={{ width: '100%' }}>
                                                    <table border="1" cellPadding="0" cellSpacing="0" width="675" style={{ width: '100%' }}>
                                                        <thead>
                                                            <tr>
                                                                <th>To</th>
                                                                <th>At</th>
                                                                <th>Duration</th>
                                                                <th>Cost ($)</th>
                                                                <th>From (Location)</th>
                                                                <th>To (Location)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {report?.sMSDetails?.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{formateMdnNumber(item?.column2)}</td>
                                                                    <td>{formatDateTime3(item?.column3,item?.column4)}</td>
                                                                    <td>{convertMinToHours(parseFloat(item?.column5))}</td>
                                                                    <td>{formatCurrency(item?.column6)}</td>
                                                                    <td>{item?.column7}</td>
                                                                    <td>{item?.column8}</td>
                                                                </tr>
                                                            )) || (
                                                                    <tr>
                                                                        <td colSpan="6" style={{ textAlign: 'center' }}>No SMS/MMS Details Available</td>
                                                                    </tr>
                                                                )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div className="page_container">
                                                <h2 style={{ textAlign: 'center', margin: '19px 0' }}>Call Details</h2>
                                                <div>
                                                    <table border="1" cellPadding="0" cellSpacing="0" width="100%">
                                                        <thead>
                                                            <tr>
                                                                <th>To</th>
                                                                <th>At</th>
                                                                <th>Duration</th>
                                                                <th>Cost ($)</th>
                                                                <th>From (Location)</th>
                                                                <th>To (Location)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {report?.callDetails?.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{formateMdnNumber(item?.column2)}</td>
                                                                    <td>{formatDateTime3(item?.column3, item?.column4)}</td>
                                                                    <td>{convertMinToHours(parseFloat(item?.column5))}</td>
                                                                    <td>{formatCurrency(item?.column6)}</td>
                                                                    <td>{item?.column7}</td>
                                                                    <td>{item?.column8}</td>
                                                                </tr>
                                                            )) || (
                                                                    <tr>
                                                                        <td colSpan="6" style={{ textAlign: 'center' }}>No Call Details Available</td>
                                                                    </tr>
                                                                )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div className="page_container">
                                                <h2 style={{ textAlign: 'center', margin: '19px 0' }}>Data Details</h2>
                                                <table border="1" cellPadding="0" cellSpacing="0" width="675" style={{ width: '100%' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>To</th>
                                                            <th>At</th>
                                                            <th>Duration</th>
                                                            <th>Cost ($)</th>
                                                            <th>From (Location)</th>
                                                            <th>To (Location)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {report?.dataDetails?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{formateMdnNumber(item?.column2)}</td>
                                                                <td>{formatDateTime3(item?.column3, item?.column4)}</td>
                                                                <td>{convertMinToHours(parseFloat(item?.column5))}</td>
                                                                <td>{formatCurrency(item?.column6)}</td>
                                                                <td>{item?.column7}</td>
                                                                <td>{item?.column8}</td>
                                                            </tr>
                                                        )) || (
                                                                <tr>
                                                                    <td colSpan="6" style={{ textAlign: 'center' }}>No Data Details Available</td>
                                                                </tr>
                                                            )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                           </div>
                        </Scrollbars>
                    </div>

                    <div className={classes.footer}>

                        <div className={classes.footerRight}>
                            <Button className={classes.changeBtn} onClick={printReport}>Print</Button>
                            <Button className={classes.changeBtn} onClick={handleClose}>Close</Button>

                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    )
}

export default withSnackbar(MonthlyUsageSummary)